import React from 'react';

import { Stack, type StackProps } from '@atlaskit/primitives/compiled';

export const KnowledgeCardContent = (props: StackProps) => {
	return <Stack {...props} />;
};
